import { render, staticRenderFns } from "./DelayedDisplay.vue?vue&type=template&id=5578219a&"
import script from "./DelayedDisplay.vue?vue&type=script&lang=ts&"
export * from "./DelayedDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports